import { combineReducers } from 'redux-immutablejs';
// import { connectRouter } from 'connected-react-router';
import globalReducer from './global';
import toastReducer from './toast';
/**
 * The application's main reducer
 */
export default () =>
  combineReducers({
    global: globalReducer,
    toast: toastReducer
  });
